<script lang="ts">
  import Feeds from "src/app/views/Feeds.svelte"
</script>

<Feeds {...$$props} />
